<section
  *transloco="let t"
  class="content"
  [class.widescreen]="(biggerThan$ | async)?.sm">
  <div class="flex flex-col">
    @if (order) {
      <div class="header">
        <h1 class="title">{{ t('title_delivery_created') }}</h1>
        @if (!order.email) {
          @if (order.states?.payment === 'WAITING') {
            <h4>{{ t('label_email_confirmation') }}</h4>
          } @else {
            <h4>{{ t('contact_support_if_no_email_received') }}</h4>
          }
          <h4>{{ t('contact_support_if_no_email_received') }}</h4>
        }
        @if (order.email) {
          @if (order.states?.payment === 'WAITING') {
            <h4>{{ t('label_email_confirmation') }}</h4>
          } @else {
            <span>{{ t('label_track_email') }}</span>
            <strong>{{ order.email }}</strong>
          }
        }
      </div>
    }
    <span class="fixed-space-16" aria-hidden="true"></span>

    @if (order) {
      <section
        class="popsy-card light-gray block"
        [class.phone]="(lessThan$ | async)?.mobileL === true">
        <!-- Order Products -->
        <div
          [class.product-block]="(biggerThan$ | async)?.sm"
          class="flex flex-col flex-grow">
          <app-checkout-order-summary
            [deliveryProducts]="order.order"
            [insurances]="order.insurances"
            [productCountry]="order.storeCountry"
            [total]="order.totalPrice"
            [discount]="order.discount"
            [deliveryPrice]="null"
            [deliveryFee]="null"
            [isCheckout]="false">
          </app-checkout-order-summary>
          <span class="fixed-space-32" aria-hidden="true"></span>
        </div>
        @if ((biggerThan$ | async)?.sm) {
          <span class="fixed-space-32" aria-hidden="true"></span>
        }
        <!-- Delivery Status Column -->
        <div class="flex-grow">
          <!-- Confirm message -->
          <ng-container>
            <div class="popsy-card">
              <span class="fixed-space-24" aria-hidden="true"></span>
              @if (
                order.states?.order === 'WAITING_PAYMENT' &&
                order.states?.payment !== 'APPROVED'
              ) {
                <h3>{{ t('title_delivery_status_processing') }}</h3>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span class="line" aria-hidden="true"></span>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span class="break-spaces">{{
                  t('message_track_delivery_status_pending')
                }}</span>
              }
              @if (
                order.states?.order === 'READY_TO_SHIP' ||
                order.states?.payment === 'APPROVED'
              ) {
                <h3>{{ t('title_track_delivery_status_confirmed') }}</h3>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span class="line" aria-hidden="true"></span>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span>{{ t('message_track_delivery_status_confirmed') }}</span>
              }
              @if (order.states?.order === 'IN_TRANSIT') {
                <h3>{{ t('title_track_delivery_satatus_delivering') }}</h3>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span class="line" aria-hidden="true"></span>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span>{{ t('message_track_delivery_status_delivering') }}</span>
              }
              @if (order.states?.order === 'DELIVERED') {
                <h3>{{ t('title_track_delivery_satus_delivered') }}</h3>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span class="line" aria-hidden="true"></span>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span>{{ t('message_track_delivery_satus_delivered') }}</span>
              }
              @if (order.states?.order === 'CANCELLED') {
                <h3>
                  {{ t('msg_title_delivery_status_cancelled') }}
                </h3>
              }
              @if (order.states?.order === 'RETURN_IN_PROGRESS') {
                <h3>{{ t('title_track_delivery_status_returning') }}</h3>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span class="line" aria-hidden="true"></span>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span>{{ t('message_track_delivery_status_returning') }}</span>
              }
              @if (order.states?.order === 'RETURN_COMPLETED') {
                <h3>{{ t('title_track_delivery_status_returned') }}</h3>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span class="line" aria-hidden="true"></span>
                <span class="fixed-space-16" aria-hidden="true"></span>
                <span>{{ t('message_track_delivery_status_returned') }}</span>
              }
              <span class="fixed-space-16" aria-hidden="true"></span>
            </div>
          </ng-container>
          <!-- Payment Approved case for Quara -->
          @if (order.states?.payment === 'APPROVED') {
            <span class="fixed-space-32" aria-hidden="true"></span>
            <popsy-order-tracking-status
              [status]="'READY_TO_SHIP'"
              [loading]="loading"></popsy-order-tracking-status>
          }
          <!-- Delivery Status Overview -->
          @if (order.states?.payment === 'PAID') {
            <span class="fixed-space-32" aria-hidden="true"></span>
            <popsy-order-tracking-status
              [status]="order.states?.order || null"
              [packages]="order.packages"
              [loading]="loading"></popsy-order-tracking-status>
          }
          <!-- User Details -->
          @if (order.shippingAddress) {
            <span class="fixed-space-32" aria-hidden="true"></span>
            <div class="popsy-card">
              <popsy-address-details-overview
                [address]="order.shippingAddress"
                [country]="order.storeCountry"
                [email]="order.email"
                [fullName]="order.customerDetails?.name"
                [contactDetails]="
                  order.customerDetails?.contact
                "></popsy-address-details-overview>
            </div>
          }
          <!-- FAQ -->
          <span class="fixed-space-32" aria-hidden="true"></span>
          <div class="popsy-card">
            <span class="fixed-space-24" aria-hidden="true"></span>

            <a
              class="link"
              [routerLink]="getfaqFragment()"
              [queryParams]="queryParamsToKeep$ | async"
              [attr.aria-label]="t('aria_link_faq')">
              {{ t('aria_link_faq') }}
            </a>

            <span class="fixed-space-24" aria-hidden="true"></span>
          </div>
          @if (mode === 'public_buyer' && !(loggedUserId$ | async)) {
            <span class="fixed-space-24" aria-hidden="true"></span>
            <span class="line" aria-hidden="true"></span>
            <span class="fixed-space-24" aria-hidden="true"></span>
            <a
              class="popsy-button-option"
              [name]="t('action_view_all_deliveries')"
              (click)="openAuthDialog()"
              [routerLink]="userProfileUrlFragment$ | async"
              [queryParams]="queryParamsToKeep$ | async"
              [fragment]="'deliveries'">
              {{ t('msg_sign_in') }}
            </a>
          }
          @if ((loggedUserId$ | async) && (lessThan$ | async)?.md === true) {
            <span class="fixed-space-16" aria-hidden="true"></span>
            <span class="line" aria-hidden="true"></span>
            <span class="fixed-space-16" aria-hidden="true"></span>
            <a
              class="popsy-button-option"
              [name]="t('action_view_all_deliveries')"
              [routerLink]="userProfileUrlFragment$ | async"
              [queryParams]="queryParamsToKeep$ | async"
              [fragment]="'deliveries'">
              {{ t('action_view_all_deliveries') }}
            </a>
          }
        </div>
      </section>
    }
    <span class="fixed-space-32" aria-hidden="true"></span>
  </div>
</section>
